module.exports = __webpack_public_path__ + "img/brand_stackoverflow.6aad3d3e.svg";